export const questions = [
  {
    "id": "Q1",
    "section": "Relationship with investors",
    "description": "As a founder, your relationship with investors shapes your ability to lead with focus, resilience, and long-term vision. When built on trust, transparency, and shared belief, it fuels confidence and creative momentum. But when strained, it breeds misalignment, short-term pressure, and emotional drag, limiting your freedom to build boldly.",
    "text": "I feel trusted by our investors to make the right strategic decisions for the long-term health and growth of the business"
  },
  {
    "id": "Q2",
    "section": "Relationship with investors",
    "text": "I have regular, outcome focused conversations with investors or the board that challenge and support our direction"
  },
  {
    "id": "Q3",
    "section": "Relationship with investors",
    "text": "I feel our investors genuinely understand our vision and the journey we're on"
  },
  {
    "id": "Q4",
    "section": "Relationship with investors",
    "text": "I believe our investors are aligned with us on what success looks like and how we get there"
  },
  {
    "id": "Q5",
    "section": "Relationship with investors",
    "text": "When the business performs well, I feel that success is recognised and championed by our investors"
  },
  {
    "id": "Q6",
    "section": "Relationship with investors",
    "text": "I feel confident challenging investor perspectives when needed and that input is respected"
  },
  {
    "id": "Q7",
    "section": "Relationship with investors",
    "text": "I feel energised after board meetings or investor updates"
  },
  {
    "id": "Q8",
    "section": "Relationship with the business",
    "description": "As a founder, you are the context. To lead well, you need a clear, honest view of where the business stands, its momentum, challenges, product performance, and direction. Are you scaling fast or fighting for stability? Are priorities sharp or shifting? When you stay grounded in the reality of the business, your decisions land better. When you drift, clarity, confidence, and impact suffer.",
    "text": "I feel clear and focused on our short and long term growth goals and confident they're still the right ones"
  },
  {
    "id": "Q9",
    "section": "Relationship with the business",
    "text": "I feel confident that our business model supports our most urgent priorities and can scale as we grow"
  },
  {
    "id": "Q10",
    "section": "Relationship with the business",
    "text": "I have visibility into how the business is performing across key areas: sales, product, operations, finance, marketing and so forth"
  },
  {
    "id": "Q11",
    "section": "Relationship with the business",
    "text": "There's consistency and clarity in the strategic direction shared across the leadership team"
  },
  {
    "id": "Q12",
    "section": "Relationship with the business",
    "text": "I'm actively planning for potential changes like M&A, restructuring, or strategic shifts that could shape our next phase"
  },
  {
    "id": "Q13",
    "section": "Relationship with the business",
    "text": "I feel the business is in a healthy place, culturally, financially and operationally"
  },
  {
    "id": "Q14",
    "section": "Relationship with the business",
    "text": "I believe our current product or service offering is competitively strong in our market"
  },
  {
    "id": "Q15",
    "section": "Relationship with the market",
    "description": "This is your connection to customers, competitors, and the trends reshaping your world. When this relationship is strong, you don't just respond to the market, you help shape it. You spot opportunities early, influence leadership with insight, and stay ahead of change. But when you're out of sync, you risk guessing, reacting, or missing what really matters.",
    "text": "I have a clear, current understanding of what matters most to our customers and prospects?"
  },
  {
    "id": "Q16",
    "section": "Relationship with the market",
    "text": "I regularly track and review how our competitors are positioning and evolving their offerings?"
  },
  {
    "id": "Q17",
    "section": "Relationship with the market",
    "text": "I understand how buying behaviours are shifting in our category?"
  },
  {
    "id": "Q18",
    "section": "Relationship with the market",
    "text": "I feel confident speaking on behalf of the market inside leadership or investor conversations?"
  },
  {
    "id": "Q19",
    "section": "Relationship with the market",
    "text": "I have reliable systems or methods for capturing market intelligence on an ongoing basis?"
  },
  {
    "id": "Q20",
    "section": "Relationship with the market",
    "text": "I proactively share market trends, customer insights, or competitive moves with the wider business?"
  },
  {
    "id": "Q21",
    "section": "Relationship with the market",
    "text": "I feel that my understanding of the market gives us an edge when shaping strategy or messaging?"
  },
  {
    "id": "Q22",
    "section": "Relationship with partners",
    "description": "As a founder, your external partners, agencies, advisors, delivery firms, developers, consultants are critical to your ability to scale. These relationships should bring capability, challenge, and trust. When they click, they expand your impact and free you to focus. But when they're misaligned, they create friction, waste, and drag. The right partnerships don't just support growth they accelerate it.",
    "text": "I trust our key partners and vendors to consistently deliver high-quality work that supports our goals?"
  },
  {
    "id": "Q23",
    "section": "Relationship with partners",
    "text": "I feel our partners bring fresh thinking, strategic challenge, and proactive support?"
  },
  {
    "id": "Q24",
    "section": "Relationship with partners",
    "text": "Our tech stack is structured to support automation, measurement, and operational efficiency?"
  },
  {
    "id": "Q25",
    "section": "Relationship with partners",
    "text": "I have clarity on which partners we rely on for which parts of our delivery model?"
  },
  {
    "id": "Q26",
    "section": "Relationship with partners",
    "text": "We're getting a good return on investment from our external partner spend?"
  },
  {
    "id": "Q27",
    "section": "Relationship with partners",
    "text": "Our partners understand our goals and tailor their approach accordingly?"
  },
  {
    "id": "Q28",
    "section": "Relationship with partners",
    "text": "I feel these relationships increase the overall capability and performance of the business?"
  },
  {
    "id": "Q29",
    "section": "Relationship with your team",
    "description": "Your team is where leadership becomes visible. It reflects how clearly you set direction, structure capability, and empower growth not just of the business, but of people. When the relationship is strong, you build clarity, energy, and pride. When it's weak, confusion, burnout, and disengagement creep in. This is where your vision becomes reality and your impact becomes legacy.",
    "text": "I feel confident that my team is clear on our goals and their role in achieving them?"
  },
  {
    "id": "Q30",
    "section": "Relationship with your team",
    "text": "I believe our team has the right mix of skills, mindsets, and capacity to deliver at the level required?"
  },
  {
    "id": "Q31",
    "section": "Relationship with your team",
    "text": "I have a structured, intentional approach to developing my team members?"
  },
  {
    "id": "Q32",
    "section": "Relationship with your team",
    "text": "I feel proud of how our team shows up, collaborates, and contributes to the business?"
  },
  {
    "id": "Q33",
    "section": "Relationship with your team",
    "text": "I regularly celebrate progress and recognise great work across the team?"
  },
  {
    "id": "Q34",
    "section": "Relationship with your team",
    "text": "I'm balancing internal delivery with agency or partner support in a way that builds team confidence and scale?"
  },
  {
    "id": "Q35",
    "section": "Relationship with your team",
    "text": "I feel the team trusts me to lead, support, and advocate for them?"
  },
  {
    "id": "Q36",
    "section": "Relationship with your role",
    "description": "As a founder, your role isn't just a job it's a reflection of your vision, values, and identity. But when boundaries blur and expectations balloon, it's easy to feel stretched thin or stuck in survival mode. When this relationship is clear and intentional, your role becomes a platform for growth. When it's not, the pressure mounts and joy fades even in a business you believe in.",
    "text": "I feel clear on the scope of my role as founder where to focus, what to own, and what to let go of"
  },
  {
    "id": "Q37",
    "section": "Relationship with your role",
    "text": "I spend the majority of my time on the right things strategic, high-impact work"
  },
  {
    "id": "Q38",
    "section": "Relationship with your role",
    "text": "I feel the business understands and respects the breadth of my role"
  },
  {
    "id": "Q39",
    "section": "Relationship with your role",
    "text": "I'm using the freedom of my role intentionally, shaping how I lead and where I make the biggest impact"
  },
  {
    "id": "Q40",
    "section": "Relationship with your role",
    "text": "I feel energised by the day-to day demands of being a founder"
  },
  {
    "id": "Q41",
    "section": "Relationship with your role",
    "text": "I feel my role is evolving in step with the business and still aligned with how I want to grow as a leader"
  },
  {
    "id": "Q42",
    "section": "Relationship with your role",
    "text": "If someone asked me to describe the impact I'm making in this role, I'd be proud of the answer"
  },
  {
    "id": "Q43",
    "section": "Relationship with yourself",
    "description": " This is the relationship that sets the tone for every other one, your mindset, energy, belief, and clarity of ambition. When it's strong, you lead with calm conviction and creative courage. When it's not, doubt creeps in, burnout builds, and you stop growing. Staying connected to yourself means owning your development, trusting your instincts, and protecting the joy that fuels your leadership.",
    "text": "I feel confident in my ability to lead, influence and make an impact at this level"
  },
  {
    "id": "Q44",
    "section": "Relationship with yourself",
    "text": "I regularly invest time in my own learning, development and growth"
  },
  {
    "id": "Q45",
    "section": "Relationship with yourself",
    "text": "I have a clear vision for my own career direction over the next 1-3 years"
  },
  {
    "id": "Q46",
    "section": "Relationship with yourself",
    "text": "I feel I'm managing my time and energy in a way that supports both performance and wellbeing"
  },
  {
    "id": "Q47",
    "section": "Relationship with yourself",
    "text": "I actively seek out feedback and remain open to challenge and different perspectives"
  },
  {
    "id": "Q48",
    "section": "Relationship with yourself",
    "text": "I recognise and celebrate my own progress and achievements"
  },
  {
    "id": "Q49",
    "section": "Relationship with yourself",
    "text": "I feel proud of the way I'm showing up as a leader day to day"
  },
  {
    "id": "Q50",
    "section": "Relationship with your Co-Founder",
    "description": "This is the relationship that most deeply influences the foundations of your business. When it's strong, it creates clarity, courage and cohesion at the top. When it's strained, it can cloud decision making, erode trust, and slow everything down. Investing in your Co-founder relationship means building mutual respect, having hard conversations early, and staying aligned on the journey you're choosing to share.",
    "text": "We're evolving together as leaders and regularly check in on what the business and each other need from us"
  },
  {
    "id": "Q51",
    "section": "Relationship with your Co-Founder",
    "text": "I feel we have a shared vision and are aligned on the goals and direction of the business."
  },
  {
    "id": "Q52",
    "section": "Relationship with your Co-Founder",
    "text": "We're clear on our respective roles, responsibility, accountability and decision making boundaries."
  },
  {
    "id": "Q53",
    "section": "Relationship with your Co-Founder",
    "text": "I trust my co-founder to handle their side of the business with integrity and care."
  },
  {
    "id": "Q54",
    "section": "Relationship with your Co-Founder",
    "text": "We can disagree openly and work through conflict in a constructive way."
  },
  {
    "id": "Q55",
    "section": "Relationship with your Co-Founder",
    "text": "I feel seen, valued, and supported by my co-founder as a leader and person."
  },
  {
    "id": "Q56",
    "section": "Relationship with your Co-Founder",
    "text": "We regularly make time to reflect on our partnership and how it's working."
  }
]